import { Grid2 as Grid } from '@mui/material';
import { AccordionForm, AccordionFormPanelProps as Props } from '@react-admin/ra-form-layout';
import { Labeled, ReferenceField, required, TextField, TextInput } from 'react-admin';
import { ReactElement } from 'react';
import { CurrencyAmountInput } from '../../../../Components/CurrencyAmount/CurrencyAmountInput';
import ImageUrlInput from '../../../../Components/ImageUrlInput';

export default function OfferDetailsSection(props: Omit<Props, 'children'>): ReactElement {
  return (
    <AccordionForm.Panel {...props}>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <TextInput label="Name" source="attributes.name" validate={[required()]} />
          <TextInput label="Description" source="attributes.description" multiline />
          <ImageUrlInput label="Image" source="attributes.image_url" />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }} spacing={2}>
          <Labeled label="Merchant" sx={{ mr: 2, mb: 2 }}>
            <ReferenceField reference="merchants" source="relationships.merchant.data.id">
              <TextField source="attributes.merchant_name" />
            </ReferenceField>
          </Labeled>
          <Labeled label="Site ID">
            <TextField source="attributes.site_id" />
          </Labeled>
          <TextInput label="Offer URL" source="attributes.url" validate={[required()]} />
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, lg: 6 }}>
              <CurrencyAmountInput
                label="Offer Price"
                source="attributes.offer_price"
                validate={[required()]}
              />
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <CurrencyAmountInput label="Retail Price" source="attributes.retail_price" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionForm.Panel>
  );
}
